// Import custom scripts and files
import './plugins/Craft';
import Alpine from '@alpinejs/csp';
import focus from '@alpinejs/focus';
import '@tailwindplus/elements';
import initGlobalJS from './components/GlobalJs';
import initHeader from './components/Header';
import initHero from './components/Hero';
import initCardSlider from './components/CardSlider';
import initVideo from './components/Video';
import initAccordion from './components/Accordion';
import initGallery from './components/Gallery';
import initAudioPlayer from './components/AudioPlayer';
import initCopyToClipboard from './components/CopyToClipboard';
import initDropdown from './components/Dropdown';
import initSlideOut from './components/SlideOut';
import { checkIfPayerReady } from './utils/VideoUtils';
import initCookieConsent from './components/CookieConsent';
import initPopup from './components/Popup';

Alpine.plugin(focus);
window.Alpine = Alpine;
const startingWith = (subject: string, replacement: string) => (
  { name, value }: { name: string; value: string },
) => {
  if (name.startsWith(subject)) {
    // eslint-disable-next-line no-param-reassign
    name = name.replace(subject, replacement);
  }
  return { name, value };
};

document.addEventListener('alpine:init', () => {
  Alpine.prefix('data-x-');
  Alpine.mapAttributes(startingWith('data-x-show', Alpine.prefixed('show')));
  Alpine.mapAttributes(startingWith('data-x-on.', Alpine.prefixed('on:')));
  Alpine.mapAttributes(startingWith('data-x-bind.', Alpine.prefixed('bind:')));
  Alpine.mapAttributes(startingWith('data-x-ref', Alpine.prefixed('ref')));
  Alpine.mapAttributes(startingWith('data-x-bind.', Alpine.prefixed('bind:')));
  Alpine.mapAttributes(startingWith('data-x-cloak', Alpine.prefixed('cloak')));
  Alpine.mapAttributes(startingWith('data-x-transition.', Alpine.prefixed('transition:')));
  Alpine.mapAttributes(startingWith('data-x-trap', Alpine.prefixed('trap')));
  Alpine.mapAttributes(startingWith('data-x-text', Alpine.prefixed('text')));
  Alpine.mapAttributes(startingWith('data-x-init', Alpine.prefixed('init')));
  Alpine.mapAttributes(startingWith('data-x-model', Alpine.prefixed('model')));
  checkIfPayerReady();
  initGlobalJS();
  initHeader();
  initHero();
  initCardSlider();
  initVideo();
  initAccordion();
  initGallery();
  initAudioPlayer();
  initCopyToClipboard();
  initDropdown();
  initSlideOut();
  initCookieConsent();
  initPopup();
});

Alpine.start();
